import React from 'react';

import s from './ProgressBar.module.scss';

interface Props {
  currentSlide: number;
  count: number;
}

export default function ProgressBar({
  currentSlide,
  count,
}: Props): JSX.Element {
  return (
    <div className={s.wrapper}>
      <div
        className={s.progress}
        style={{ width: `${((currentSlide + 1) / count) * 100}%` }}
      />
    </div>
  );
}
